import request from '@/utils/request'
import URL from './urlTranslator'

// 获取财务月列表
export function getAccountingMonthList(params) {
  return request({
    url: URL.mdm.accountingMonth.accountingMonthInfo,
    method: 'get',
    params
  })
}

// 新增财务月
export function addAccountingMonth(data) {
  return request({
    url: URL.mdm.accountingMonth.accountingMonthInfo,
    method: 'post',
    data
  })
}

// 编辑财务月
export function updateAccountingMonth(data) {
  return request({
    url: URL.mdm.accountingMonth.accountingMonthInfo,
    method: 'put',
    data
  })
}

// 删除财务月
export function batchDelAccountingMonth(data) {
  return request({
    url: URL.mdm.accountingMonth.accountingMonthInfo,
    method: 'delete',
    data
  })
}
